import React, { useEffect, useState } from "react";
import { getPatientBladderJournal } from "../services/patientService";
import { toast } from "react-toastify";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import Loader from "../../utils/Loader";
export default function BladderPainList({ data, type }) {
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [bladderJournalList, setBladderJournalList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    __getPatientBladderJournal();
  }, [data, page, limit]);

  const __getPatientBladderJournal = async () => {
    try {
      setLoading(true);
      const response = await getPatientBladderJournal(data, {
        page: page + 1,
        limit,
        type: type || "voids",
      });
      
      if (response?.status === "SUCCESS") {
        setBladderJournalList(response?.data?.list || []);
        setTotalItems(response?.data?.totalItems);
        setTotalPages(response?.data?.totalPages);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.message);
      }
    } catch (err) {
      setLoading(false);
      console.error("Error fetching patient bladder journal:", err);
    }
  };

  // ******************************Pagination logic ***********************************************************
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      {loading && <Loader />}
      {/* table for drink list  */}
      {type === "Drink" && (
        <div className="table-responsive dashboard-table">
          <table className="patients-table">
            <thead>
              <tr className="t-row-block">
                <th scope="col">Sr No</th>
                <th scope="col">Drink Type</th>
                <th scope="col">Amount</th>
                <th scope="col">Note</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              {bladderJournalList?.length > 0 ? (
                bladderJournalList?.map((journal, index) => (
                  <tr key={journal.id || index}>
                    <td scope="row" style={{ borderLeft: "0px" }}>
                      {++index}
                    </td>
                    <td className="text-capitalize">
                      {journal?.drink?.drinkType}
                    </td>
                    <td>{journal?.drink.amount || 0} ml</td>
                    <td className="text-capitalize">{journal?.notes || "-"}</td>

                    <td>
                      {journal?.createdAt
                        ? new Date(journal.createdAt).toLocaleString(
                            undefined,
                            {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            }
                          )
                        : "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Fluid Intake Found
                  </td>
                </tr>
              )}

              <tr></tr>
            </tbody>
          </table>
        </div>
      )}

      {/* list for urination / voids */}
      {type === "Urination" && (
        <div className="table-responsive dashboard-table">
          <table className="patients-table">
            <thead>
              <tr className="t-row-block">
                <th scope="col">Sr No</th>
                <th scope="col">Duration</th>
                <th scope="col">Amount</th>
                <th scope="col">Urgency</th>
                <th scope="col">Pain</th>
                <th scope="col">Urine Stream</th>
                <th scope="col">Leaking</th>
                <th scope="col">Note</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              {bladderJournalList?.length > 0 ? (
                bladderJournalList?.map((journal, index) => (
                  <tr key={journal.id || index}>
                    <td scope="row" style={{ borderLeft: "0px" }}>
                      {++index}
                    </td>
                    <td className="text-capitalize">
                      {journal?.urination?.duration || "-"} sec
                    </td>
                    <td>{journal?.urination.amount || 0} ml</td>
                    <td className="text-capitalize">
                      {journal?.urination.urgencyLevel || "-"}
                    </td>
                    <td className="text-capitalize">
                      {journal?.urination.painLevel || "-"}
                    </td>
                    <td className="text-capitalize">
                      {journal?.urination.urinStream || "-"}
                    </td>
                    <td className="text-capitalize">
                      {journal?.urination.leaking || "-"}
                    </td>
                    <td className="text-capitalize">{journal?.notes || "-"}</td>
                    <td>
                      {journal?.createdAt
                        ? new Date(journal.createdAt).toLocaleString(
                            undefined,
                            {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            }
                          )
                        : "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Voids Found
                  </td>
                </tr>
              )}

              <tr></tr>
            </tbody>
          </table>
        </div>
      )}

      <div className="pagination-blk">
        <CustomPagination
          totalItems={totalItems}
          page={page}
          onPageChange={handleChangePage}
          limit={limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </>
  );
}
